if (navigator.share) {
  const webShare = document.querySelector('.web-share');
  webShare.classList.remove('d-none');
  webShare.addEventListener('click', (event) => {
    event.preventDefault();
    navigator.share({ url: webShare.href }).catch(() => {});
  });
} else if (typeof global.isInStandaloneMode !== 'undefined' && global.isInStandaloneMode()) {
  document.querySelector('.not-web-share').classList.remove('d-none');
}
